import React, { useState } from "react";
import JobListPanel from "./JobListPanel"
import { jobs } from "./jobListingsData"
import JobDetails from "./JobDetails";

const JobPostDashBoard = () => {
    const [selectedJob, setSelectedJob] = useState(jobs[0]);

    return (
        <div className="flex flex-col">
            <div className="space-y-6">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    <div className="col-span-1">
                        <JobListPanel 
                            jobs={jobs}
                            selectedJob={selectedJob}
                            onSelect={setSelectedJob}
                        />
                    </div>
                    <div className="col-span-2 space-y-6">
                        <JobDetails />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JobPostDashBoard;